document.addEventListener('DOMContentLoaded', () => {
  const searchGrid = document.querySelector('[data-fabric-search]');
  if (searchGrid) {
    const words = value => (value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(/[\p{L}\p{N}]+/gu) || [];
    const terms = words(searchGrid.dataset.query);
    const status = document.querySelector('[data-search-status]');
    const searchParams = new URLSearchParams(location.search);
    (async () => {
      const cards = [];
      let next = searchGrid.dataset.indexUrl;
      const visited = new Set();
      while (next) {
        const url = new URL(next, location.origin);
        url.searchParams.set('view', 'search-index');
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid search pagination');
        visited.add(url.href);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Search unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const index = page.querySelector('[data-search-index]');
        if (!index) throw new Error('Search index unavailable');
        cards.push(...index.querySelectorAll('.product-card'));
        next = index.dataset.next;
      }
      if (searchParams.get('finder') === '1' && window.VelisseFabricFinder) {
        const selection = window.VelisseFabricFinder.filterProducts(cards.map(card => ({
          card,
          kind: card.dataset.finderKind,
          family: card.dataset.finderFamily,
          type: card.dataset.finderType,
          stretch: card.dataset.finderStretch,
          price: Number(card.dataset.finderPriceCents || 0) / 100,
        })), searchParams);
        selection.products.forEach(product => searchGrid.append(document.importNode(product.card, true)));
        const count = selection.products.length;
        status.textContent = count ? `${count} recommended ${count === 1 ? 'fabric' : 'fabrics'}` : 'No matching fabrics found.';
        document.dispatchEvent(new CustomEvent('fabric-finder:results', { detail: { relaxed: selection.relaxed, count } }));
        document.title = `Fabric Finder: ${count} recommendations — Velisse Fabrics`;
        return;
      }
      const colorVocabulary = new Set(cards.flatMap(card => [...card.querySelectorAll('[data-color-search]')].flatMap(color => words(color.dataset.colorSearch))));
      const colorTerms = terms.filter(term => colorVocabulary.has(term));
      let count = 0;
      for (const card of cards) {
        const common = words(card.dataset.searchAttributes);
        const colors = [...card.querySelectorAll('[data-color-search]')];
        const matching = colors.filter(color => {
          const colorWords = words(color.dataset.colorSearch);
          return terms.every(term => common.includes(term) || colorWords.includes(term)) && colorTerms.every(term => colorWords.includes(term));
        });
        const productMatch = terms.every(term => common.includes(term));
        if (!matching.length && !productMatch) continue;
        if (colors.length && !matching.length) {
          colors.forEach(color => color.remove());
          if (colorTerms.length) {
            const image = card.querySelector('.product-card__image');
            image.replaceChildren();
            const note = document.createElement('p');
            note.className = 'search-description-match';
            note.textContent = 'Matches fabric description or attributes';
            image.append(note);
          }
        }
        if (matching.length) {
          colors.filter(color => !matching.includes(color)).forEach(color => color.remove());
          const color = matching[0];
          const link = card.querySelector(':scope > a');
          link.href = color.href;
          for (const key of ['restockId', 'restockTitle']) {
            if (color.dataset[key]) link.dataset[key] = color.dataset[key];
            else delete link.dataset[key];
          }
          let badge = card.querySelector('.badge');
          if (!badge && color.dataset.available === 'false') {
            badge = document.createElement('span'); badge.className = 'badge'; badge.textContent = 'Sold out';
            card.querySelector('.product-card__image').append(badge);
          }
          if (badge) badge.hidden = color.dataset.available !== 'false';
          let invitation = card.querySelector('.restock-hover');
          if (!invitation && color.dataset.restockId) {
            invitation = document.createElement('span'); invitation.className = 'restock-hover'; invitation.textContent = 'Notify me when available';
            card.querySelector('.product-card__image').append(invitation);
          }
          if (invitation) invitation.hidden = !color.dataset.restockId;
          const thumb = color.querySelector('img');
          const main = card.querySelector('.product-card__image img');
          if (thumb && main) {
            const imageUrl = new URL(thumb.src, location.origin);
            imageUrl.searchParams.set('width', '900');
            main.src = imageUrl.href;
            main.removeAttribute('srcset');
            main.alt = color.dataset.colorTitle;
          }
          card.querySelector('.product-card__meta p').textContent = color.dataset.colorPrice;
        }
        searchGrid.append(document.importNode(card, true));
        count++;
      }
      status.textContent = count ? `${count} matching ${count === 1 ? 'fabric' : 'fabrics'}` : 'No matching fabrics found.';
      document.title = `Search: ${count} results for “${searchGrid.dataset.query}” — Velisse Fabrics`;
    })().catch(() => { status.textContent = 'Search could not load. Please refresh to try again.'; });
  }
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (toggle && menu) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.classList.toggle('is-open', !open);
  });
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const input = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; });
    if (root.hasAttribute('data-managed-product')) return;
    const updateVariant = (control) => {
      const label = root.querySelector(`label[for="${control.id}"]`);
      if (label?.dataset.colorName) {
        const marker = ` - ${label.dataset.colorName} - `;
        root.querySelectorAll('[data-color-photo]').forEach(photo => {
          photo.hidden = !photo.dataset.photoAlt.includes(marker) && photo.dataset.photoId !== label.dataset.featuredPhoto;
        });
      }
      const price = control.dataset.price;
      const family = control.dataset.colorFamily;
      const unit = root.dataset.productKind === 'fabric' ? 'yard' : control.dataset.unitType;
      const draw = control.dataset.inventoryDraw;
      const available = control.dataset.available !== 'false' && !control.disabled;
      const title = control.closest('.variant-grid')?.querySelector(`label[for="${control.id}"] strong`)?.textContent?.trim();
      if (price) root.querySelector('[data-product-price]').textContent = `${price}${unit === 'yard' || unit === 'yards' ? ' / yd' : ''}`;
      if (family && root.querySelector('[data-color-family]')) root.querySelector('[data-color-family]').textContent = family;
      if (unit && root.querySelector('[data-quantity-label]')) root.querySelector('[data-quantity-label]').textContent = unit.charAt(0).toUpperCase() + unit.slice(1);
      const drawNote = root.querySelector('[data-inventory-draw]');
      if (drawNote) { drawNote.hidden = !draw; if (draw) drawNote.innerHTML = `Each unit draws <strong>${draw}</strong> yd from inventory.`; }
      const add = root.querySelector('[data-add-to-cart]');
      if (add) { add.disabled = !available; add.textContent = available ? `Add to bag${title ? ` — ${title}` : ''}` : 'Sold out'; }
      if (control.value) history.replaceState({}, '', `${location.pathname}?variant=${control.value}`);
    };
    root.querySelectorAll('[data-variant-input]').forEach((control) => control.addEventListener('change', () => updateVariant(control)));
    root.querySelector('[data-variant-select]')?.addEventListener('change', (event) => updateVariant(event.target.selectedOptions[0]));
  });
});
